import React, { memo, useMemo } from 'react';
import { StyleSheet, Text } from 'react-native';
import { FONTS } from '@bcm/constants';

import GlobalPressable from '../../UI/button/GlobalPressable';
import Image from '../../UI/image/Image';
import { SILHOUETTE_TYPES, getAgeFromEocCondition, getSilhouette } from '../../../src/silhouetteUtils';

const flipScale = 6;

const BodySiteCanvasFlipButton = ({
	toggleSide,
	dims,
	isFront,
	eoc,
	condition
}) => {

	const source = useMemo(() => {
		const side = isFront ? 'back' : 'front';
		const years = getAgeFromEocCondition(eoc, condition);
		return getSilhouette(years, side, SILHOUETTE_TYPES.flip);
	}, [isFront, condition, eoc]);

	const styles = StyleSheet.create({
		flipContainer: {
			position: 'absolute',
			height: dims.height / flipScale + 5,
			width: dims.width / flipScale + 5,
			top: 10,
			right: 15,
			zIndex: 20,
			justifyContent: 'center',
			alignItems: 'center',
		},
		flipImage: {
			height: dims.height / flipScale,
			width: dims.width / flipScale,
		},
		flipText: {
			fontFamily: FONTS.default,
		},
	});

	return (
		<GlobalPressable
			style={styles.flipContainer}
			onPress={toggleSide}
		>
			<Image
				style={styles.flipImage}
				source={source}
			/>
			<Text
				style={styles.flipText}
				numberOfLines={1}
			>
				{isFront ? 'Back' : 'Front'}
			</Text>

		</GlobalPressable>
	);
};

export default memo(BodySiteCanvasFlipButton);